<template>
    <div class="bg-wrapper">
        <div class="bg-gradient"></div>
        <div class="grid-bg"></div>
        <div class="particles" id="particles">
            <div v-for="i in particleCount" :key="i" class="particle"
                :style="{left: `${Math.random() * 100}%`, animationDelay: `${Math.random() * 20}s`, animationDuration: `${15 + Math.random() * 10}s`,}"
            ></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ParticleBackground",
    data() {
        return {
            particleCount: 50,
        };
    },
};
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

/* 动画粒子效果 */
.particles {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: -1;
}

.particle {
    position: absolute;
    width: 4px;
    height: 4px;
    background: rgba(0, 255, 150, 0.5);
    border-radius: 50%;
    animation: particle-float 20s infinite;
}

@keyframes particle-float {
    0% {
        transform: translateY(100vh) translateX(0);
        opacity: 0;
    }
    10% {
        opacity: 1;
    }
    90% {
        opacity: 1;
    }
    100% {
        transform: translateY(-10vh) translateX(100px);
        opacity: 0;
    }
}

body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC",
    "Microsoft YaHei", sans-serif;
    background: #0a0e27;
    color: #fff;
    overflow-x: hidden;
}

/* 背景效果 */
.bg-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background: #0a0e27;
}

.bg-gradient {
    position: absolute;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at 20% 80%, #1a3a52 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, #0f2847 0%, transparent 50%),
    radial-gradient(circle at 40% 40%, #162347 0%, transparent 50%);
}

.grid-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
        rgba(0, 255, 150, 0.05) 1px,
        transparent 1px
    ),
    linear-gradient(90deg, rgba(0, 255, 150, 0.05) 1px, transparent 1px);
    background-size: 50px 50px;
    animation: grid-move 20s linear infinite;
}

@keyframes grid-move {
    0% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(50px, 50px);
    }
}
</style>